module.exports = __webpack_public_path__ + "static/media/Chloroform_Body_Play.2fd8fbf4.mp3";